module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoL.b07ac29.ttf";